import { createSelector } from '../../dependencies';

const selectTags = state => state.tags;

export const selectTagListFilter = createSelector(
    selectTags,
    ({ filter }) => filter,
);
